Directives.TopNavProfileDirective = function TopNavProfileDirective() {

    // @ngInject
    function TopNavProfileDirectiveControllerFunc(
        $scope,
        $injector,
        ModalService,
        $state,
        AppStates,
        AnalyticsService,
        SetupGuideService,
        Enums,
        UsersManager,
        CompaniesManager,
        ReferralService,
        FeaturesService,
        OnboardingService,
        AuthService,
        AccountsService
    ) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TopNavProfileDirectiveController';

        this.$state = $state;
        this.AppStates = AppStates;
        this.AnalyticsService = AnalyticsService;
        this.UsersManager = UsersManager;
        this.ReferralService = ReferralService;
        this.AuthService = AuthService;
        this.SetupGuideService = SetupGuideService;
        this.FeaturesService = FeaturesService;
        this.Enums = Enums;
        this.ModalService = ModalService;
        this.OnboardingService = OnboardingService;
        this.AccountsService = AccountsService;

        this.setSubscribedUserChanges();

        this.interactiveOrStreamlinedSetupGuide = this.user.getExistingAbTestVariation(this.Enums.ABTests.interactiveOnboarding);

        CompaniesManager.on(this.Enums.PubSubTriggers.companySubscribed, function companySubscribed() {
            this.setSubscribedUserChanges();
        }.bind(this));

        this.SetupGuideService.on(this.SetupGuideService.STEP_COMPLETED_EVENT_NAME, function (step) {
            this.setSubscribedUserChanges();
        }.bind(this));

        this.hasMarkedSetupGuideComplete = this.SetupGuideService.getPersistenceHomeOnboardingCard().hasMarkedComplete;

        ////////////////////////////////////////////////////////
        // TODO (Alon): Remove from here
        // Need to use existing 'hb-refer-friend' directive,
        // but we need to rafactor it so it will fit here as
        // well. For now, extracted the logic from there
        ////////////////////////////////////////////////////////
        this.showReferrAFriend = false;
        this.ReferralService.getCampaignDetails(this.user).then(function success(campaignDetails) {
            if (campaignDetails && campaignDetails.campaign_uid) {
                this.showReferrAFriend = true;
            }
        }.bind(this));
        ////////////////////////////////////////////////////////
        // END
        ////////////////////////////////////////////////////////
    }

    var TopNavProfileDirectiveController = Class(Controllers.BaseController, {
        constructor: TopNavProfileDirectiveControllerFunc,

        logout: function logout() {
            this.AuthService.logout();
        },

        setSubscribedUserChanges: function setupUserFlyoutActions() {
            this.shouldBeAbleToUpgrade = this.user.shouldBeAbleToUpgrade();
            this.isSetupGuideLinkVisible = this.SetupGuideService.isSetupGuideActiveForSubscribedUsers();
        },

        referAFriendClick: function referAFriendClick() {
            this.$state.go(this.AppStates.root_core_navigation_invite_referrals);
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.refer_a_friend_button_click,{
                campaign_uid :this.ReferralService.userCampaignUid
            });
        },

        onItemClick: function onItemClick() {
            if(angular.isFunction(this.onSelect)) {
                this.onSelect();
            }
        },

        getEditProfileLink: function getEditProfileLink() {
            return (this.user.isCommunitySource()
                ? this.AppStates.root_network_my_profile
                : this.AppStates.root_core_navigation_settings_account)
        },

        getEditProfileAnalyticEvent: function getEditProfileAnalyticEvent() {
            //see getEditProfileLink()
            return this.user.isCommunitySource() ? 'public profile' : 'account settings';
        },

        getDaysTillTrialEnds: function getDaysTillTrialEnds() {
            return this.user && this.user.nTillTrialEnds();
        },

        onUpgradeNow: function onUpgradeNow() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action, {
                unique: 'membership page',
                source: 'user_flyout',
                trial_days_left: this.getDaysTillTrialEnds()
            });

            this.$state.go(this.AppStates.root_core_navigation_settings_companySettings_subscription);
        },

        switchCompany: function switchCompany(companyId) {
            this.AccountsService.switchCompany(companyId);
        }

    });

    return {
        scope: {
            user: '=user',
            onSelect: '&'
        },
        templateUrl: 'angular/app/modules/core/features/top_nav/profile/top_nav_profile_template.html',
        controller: TopNavProfileDirectiveController,
        controllerAs: 'topNavProfileVm',
        bindToController: true
    };
};
